'use client';

import Dropdown, { type DropdownOption } from '@pixum/dropdown';
import { type I18nConstants } from '../../../../types';
import { useEffect, useState } from 'react';
import { type Page } from 'utils';

export type CountryDropdownProps = {
  pages: Page[];
  constants: I18nConstants;
};

/**
 * Renders a dropdown component for selecting a country. Please note that this component is only rendered on the client side and
 * is not rendered on the server side to avoid duplicate indexing by bots.
 *
 * @param props - The props for the component.
 * @returns The rendered component or null if not executed on the client side
 */
export function CountryDropdown(props: CountryDropdownProps) {
  const { pages, constants } = props;
  const [hydrated, setHydrated] = useState(false);
  const options: DropdownOption[] = pages.map(({ siteBranch, name, homepage }) => ({
    id: siteBranch,
    label: name,
    text: name,
    href: homepage,
  }));

  // This will effectively remove the dropdown markup on build time and therefore avoid duplicate indexing by bots
  useEffect(() => {
    setHydrated(true);
  }, []);
  if (!hydrated) return null;

  return (
    <div className="footer__country-dropdown">
      <Dropdown options={options} label={constants['i18n_select_country_of_order'] as string} />
    </div>
  );
}
